import React, { Fragment } from 'react';
import Question from '../MultipleChoice/Question';

const Calculation = ({
  input,
  onInput,
  data,
  onCompletion,
  setSubmitStatus,
  validationResult
}) => {
  const handleClick = (question, option) => {
    const payload = {
      ...input,
      [question]: option
    };
    setSubmitStatus(Object.keys(payload).length === data.questions.length);

    if (Object.keys(payload).length === data.questions.length) {
      onCompletion();
    }
    onInput(payload);
  };

  const getSelectedOption = question => {
    if (input && question in input) {
      return input[question];
    }
    return null;
  };

  return (
    <Fragment>
      {data.questions.map((calculation, i) => {
        return (
          <Question
            key={i}
            data={calculation}
            onClick={handleClick}
            input={getSelectedOption(calculation.question)}
            validationResult={validationResult}
          />
        );
      })}
    </Fragment>
  );
};

export default Calculation;



// WEBPACK FOOTER //
// ../core/src/components/Calculation/Calculation.js